export const ClipboardDispatcher = {
  mounted() {
    this.handleEvent("clipboard_copy", ({ id, text, type, richtext }) => {
      const el = document.getElementById(id);
      if (!el) return;

      const event = new CustomEvent("phx:clipcopy", {
        bubbles: true,
        cancelable: true,
        detail: { text, type, richtext },
      });

      el.dispatchEvent(event);
    });
  },
};
